<ng-container *ngIf="(media === 'xs' || media === 'sm') else deskmode">
    <div class="calcontainermobile">
        <ng-container *ngFor="let cal of calendars | async;trackBy: trackByFn">
            <div [id]="cal.class">
                <div class="month_header-mobile">
                    <span multilang>{{cal.header | date: 'MMMM, yyyy'}}</span>
                </div>
                <ng-container *ngTemplateOutlet="mymonth; context:{month:cal}"></ng-container>
            </div>
        </ng-container>
    </div>
</ng-container>

<ng-template #deskmode>
    <div class="calwrapper">
        <div class="d-header-wrapper">
            <span multilang>{{start | date:'dd.MM.yyyy'}} {{!isOne ? ' - ' + (end | date:'dd.MM.yyy') : ''}}</span>
        </div>
        <div class="calcontainer">
            <div class="first-cal-wrapper">
                <div class="month_header">
                    <button (click)="previus()" class="dirbtn" matRipple>
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    <span multilang class="header-txt">{{first_header | date: 'MMMM, yyyy'}}</span>
                    <span multilang class="emptybtn"></span>
                </div>
                <ng-container *ngTemplateOutlet="mymonth; context:{month:first_month}"></ng-container>
            </div>
            <div class="sec-cal-wrapper">
                <div class="month_header">
                    <span multilang class="emptybtn"></span>
                    <span multilang class="header-txt">{{second_header | date: 'MMMM, yyyy'}}</span>
                    <button (click)="next()" class="dirbtn" matRipple>
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </div>
                <ng-container *ngTemplateOutlet="mymonth; context:{month:second_month}"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #mymonth let-month="month">
    <div class="caltab">
        <div class="month-wrapper">
            <span multilang class="mday" *ngFor="let hd of header_week">{{hd }}</span>
        </div>
        <div class="day-wrapper">
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_0}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_1}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_2}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_3}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_4}"></ng-container>
            </div>
            <div class="day-container">
                <ng-container *ngTemplateOutlet="cells; context:{arr:month?.w_5}"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #cells let-arr="arr">
    <ng-container *ngFor="let md of arr">
        <ng-container *ngTemplateOutlet="day; context:{md:md}"></ng-container>
    </ng-container>
</ng-template>

<ng-template #day let-md="md">
    <button (click)="selectDay(md)" (mouseleave)="selectTmp_Day(null)" (mouseenter)="selectTmp_Day(md)" class="mday-btn"
        [class.start-date-btn]="md?.id?.length > 0 && ((start?.length > 0 && md.id === start)) && !isOne"
        [class.end-date-btn]="md?.id?.length > 0 && (end?.length > 0 && md.id === end)"
        [class.included]="md?.id > start && (md?.id < tmp_end?.id || md?.id < end) && !isOne"
        [class.disabledday]="!md || md?.id < today">
        <span
            [class.start-date]="md?.id?.length > 0 && ((start?.length > 0 && md.id === start) || (end?.length > 0 && md.id === end))">{{md?.value}}</span>
    </button>
</ng-template>